module.exports = __webpack_public_path__ + "img/telegram.10fc9f18.png";